export const categoryMap = {
  admin: "Admin",
  venueManager: "Venue Manager",
  eventManager: "Event Manager",
  companyManager: "Company Manager",
};
